import React from 'react';

export const ToastError = ({ message }) => (
  <div className="toast toast-error">{message}</div>
);
